<template>
    <div class="t-lk-modal__content ">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.leadsReviewBtn }}</h2>

        <form-dynamic-cmp
            class="t-lk-modal__form t-lk-modal__review"
            :form-info="form"
            :button="props.button"
            :class-white="false"
            :action="infoForm.action"
            :lead-id="props.leadId"
            :personal-data="true"
        >
        </form-dynamic-cmp>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import formDynamic from '@components/base/form-dynamic.vue';

    export default {
        name: "request",
        props: ['props'],
        data() {
            return {
                infoForm: {
                    action: "lk/leads/review",
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
                form: {
                    "fields": [
                        {
                            "type": "form_field",
                            "content": {
                                "id": "work",
                                "title": this.$root.staticText.lk.leadModalReview,
                                "typeField": 14,
                                "requiredField": 1,
                                "description": null,
                                "list": [
                                    {
                                        "id": 1,
                                        "label": 1
                                    },
                                    {
                                        "id": 2,
                                        "label": 2
                                    },
                                    {
                                        "id": 3,
                                        "label": 3
                                    },
                                    {
                                        "id": 4,
                                        "label": 4
                                    },
                                    {
                                        "id": 5,
                                        "label": 5
                                    },
                                    {
                                        "id": 6,
                                        "label": 6
                                    },
                                    {
                                        "id": 7,
                                        "label": 7
                                    },
                                    {
                                        "id": 8,
                                        "label": 8
                                    },
                                    {
                                        "id": 9,
                                        "label": 9
                                    },
                                    {
                                        "id": 10,
                                        "label": 10
                                    },
                                ],
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "client",
                                "title": this.$root.staticText.lk.leadModalReview2,
                                "typeField": 14,
                                "requiredField": 1,
                                "description": null,
                                "list": [
                                    {
                                        "id": 1,
                                        "label": 1
                                    },
                                    {
                                        "id": 2,
                                        "label": 2
                                    },
                                    {
                                        "id": 3,
                                        "label": 3
                                    },
                                    {
                                        "id": 4,
                                        "label": 4
                                    },
                                    {
                                        "id": 5,
                                        "label": 5
                                    },
                                    {
                                        "id": 6,
                                        "label": 6
                                    },
                                    {
                                        "id": 7,
                                        "label": 7
                                    },
                                    {
                                        "id": 8,
                                        "label": 8
                                    },
                                    {
                                        "id": 9,
                                        "label": 9
                                    },
                                    {
                                        "id": 10,
                                        "label": 10
                                    },
                                ],
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "comment",
                                "title": this.$root.staticText.forms.comment2,
                                "typeField": 2,
                                "requiredField": 1,
                                "description": null,
                                "hintField": null,
                            }
                        },
                    ]
                }
            }
        },
        watch: {
            'infoForm.success': function() {
                if (this.infoForm.success) {
                    this.modalClose();
                    this.modalType_successOpen({
                        title: this.$root.staticText.modal.successTitleFeedback,
                        text: this.$root.staticText.modal.successTextFeedback,
                        class: '_small'
                    });
                }

            },
            'infoForm.error': function() {
                if (this.infoForm.error) {
                    this.modalClose();
                    this.modalType_errorOpen({
                        title: this.$root.staticText.modal.errorTitle,
                        text: this.$root.staticText.modal.errorText,
                        class: '_small'
                    });
                }
            }
        },
        components: {
            'form-dynamic-cmp': formDynamic,
        },
        methods: {
            ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-review.vue